import React from "react";
import "./AdminStaticPage.css";

const AdminStaticPage = ({ title, subtitle }) => {
  return (
    <div className="wla-static-page">
      <h1 className="wla-page-title">{title}</h1>
      {subtitle && <p className="wla-page-subtitle">{subtitle}</p>}
      <div className="wla-static-card">
        <p>This page is not available yet.</p>
      </div>
    </div>
  );
};

export default AdminStaticPage;
